import LetterbookRow from "features/Letterbooks/components/cards/LetterbookRow/LetterbookRow";
import LetterbookShelfRow from "features/Letterbooks/components/cards/LetterbookShelfRow/LetterbookShelfRow";
import LetterbookTableRow from "features/Letterbooks/components/cards/LetterbookTableRow/LetterbookTableRow";
import { LetterbookSettingType } from "features/Letterbooks/types";

const componentMap = {
  card: LetterbookRow,
  shelf: LetterbookShelfRow,
  table: LetterbookTableRow,
};

export default function AuthorRowComponent(settings: LetterbookSettingType) {
  return componentMap[settings.view];
}
